/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.5
 */

export type ReportsFindAllStatus =
  (typeof ReportsFindAllStatus)[keyof typeof ReportsFindAllStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindAllStatus = {
  publishedRRA: 'publishedRRA',
  pendingRRA: 'pendingRRA',
  draft: 'draft',
  published: 'published',
  incorrect: 'incorrect',
} as const;
